import { greaterThan, required } from 'ngrx-forms/validation';
import { updateGroup, validate, FormGroupState, ValidationErrors, setErrors } from 'ngrx-forms';
import { CalendarConfiguration } from '../../_models';

export const validateCalendarConfigurationForm = (
  calendarConfigurationForm: FormGroupState<CalendarConfiguration>
) => validateAndUpdateForm(calendarConfigurationForm);

const validateAndUpdateForm = (
  calendarConfigurationForm: FormGroupState<CalendarConfiguration>
) => {
  calendarConfigurationForm = validation(calendarConfigurationForm);
  calendarConfigurationForm = calendarViewValidation(calendarConfigurationForm);
  return calendarConfigurationForm;
};

const validation = (calendarConfigurationForm: FormGroupState<CalendarConfiguration>) => {
  const isAutoRefreshEnabled = calendarConfigurationForm.value.isAutoRefresh;

  if (isAutoRefreshEnabled) {
    return updateGroup<CalendarConfiguration>(calendarConfigurationForm, {
      autoRefreshTimeInMinutes: validate(required, greaterThan(0))
    });
  }

  return calendarConfigurationForm;
};

const calendarViewValidation = (calendarConfigurationForm: FormGroupState<CalendarConfiguration>) => {
  const errors: ValidationErrors & { staffViewRequired?: { actual: boolean; message: string }; weekViewRequired?: { actual: boolean; message: string } } = {};

  const hasStaffViewSelected =
    calendarConfigurationForm.value.staffShowTails ||
    calendarConfigurationForm.value.staffShowStaff;

  if (!hasStaffViewSelected) {
    errors.staffViewRequired = {
      actual: false,
      message: 'Please select at least one View Upon Launch option for Staff Calendar to continue'
    };
  }

  const hasWeekViewSelected =
    calendarConfigurationForm.value.weekShowTails ||
    calendarConfigurationForm.value.weekShowStaff;

  if (!hasWeekViewSelected) {
    errors.weekViewRequired = {
      actual: false,
      message: 'Please select at least one View Upon Launch option for Week Calendar to continue'
    };
  }

  return setErrors(calendarConfigurationForm, errors);
};
